import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const Footer = ({
  theme,
}) => {
  const classes = useStyles()

  const { footerNav, strings } = useSelector((state) => ({
    footerNav: state.nav.footer_menu || [],
    copyrightNav: state.nav.copyright_menu || [],
    strings: state.language.string,
  }), shallowEqual)

  return (
    <footer
      className={classNames({
        [classes.root]: true,
        [classes.footer]: true,
        [classes.themeDark]: theme === 'dark',
      })}
    >
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <div className={classes.heading} dangerouslySetInnerHTML={{ __html: strings.site_title }} />
          <div className={classes.grid}>
            <div className={classes.story} dangerouslySetInnerHTML={{ __html: strings.footer_text }} />
            <div dangerouslySetInnerHTML={{ __html: strings.footer_copy1 }} />
            <div dangerouslySetInnerHTML={{ __html: strings.footer_copy2 }} />
            <ul className={classes.footerMenu}>
              {footerNav.map((item) => (
                <li key={item.ID}>
                  <DelayLink to={item.url}>
                    {item.title}
                  </DelayLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  theme: '',
}

export default Footer
